import { HttpRequest, HttpHandlerFn, HttpEvent, HttpInterceptor, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { catchError, Observable, of, throwError } from "rxjs";
import { TimeoutError } from "rxjs";
import { Router } from "@angular/router";
import { AuthService } from "../../features/auth/auth.service";
import { ModalService } from "../../shared/components/modal/modal.service";
import { NotiflixService } from "../../shared/services/notiflix.service";
import { environment } from "@src/environments/environment";

function getAuthToken(): string | null {
  return inject(AuthService).token || null;
}

function addAuthorizationHeader(req: HttpRequest<unknown>, token: string): HttpRequest<unknown> {
  return req.clone({
    headers: req.headers
      .append("Authorization", `Bearer ${token}`)
      .set("Content-Type", "application/json")
  });
}

export function authInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): Observable<HttpEvent<unknown>> {
  const envMode = environment.mode;
  const authService = inject(AuthService);
  const notiflixService = inject(NotiflixService);
  const modalService = inject(ModalService);
  const router = inject(Router);
  const token = getAuthToken();
  const request = token ? addAuthorizationHeader(req, token) : req;

  return next(request).pipe(
    catchError(error => {


      let message = "Um erro inesperado ocorreu.";
      let status = error.status;

      if (status === 401) {
        message = "Não autenticado ou a sessão expirou."
        authService.deleteSession();
        router.navigate(["/login"]);
        modalService.destroy();

      } else if (status === 422) {
        message = error.error.message ?? error.error.error.message ?? "Requisição não processada";
      } else if (status === 0) {
        message = "Erro de comunicação com o servidor. Verifique sua conexão a internet. Se persistir contate o suporte."
      } else {

        // TODO: enquanto o login não é refatorado para o novo padrao do back
        if (error.error.message === "Usuário e/ou senha inválidos") {
          message = error.error.message
        } else {
          message = error.error.message ?? error.error.error.message ?? "Erro desconhecido. Contate o suporte!";
        }
      }

      if (error instanceof TimeoutError) {
        if (envMode === "development") {
          console.error("Erro capturado no interceptor (TIMEOUT):", error);
        }
      } else {
        if (envMode === "development") {
          console.error("Erro capturado no interceptor: ", error);
        }
      }

      const errorResponse = {
        message: message,
        status: status,
        error: error
      };
      return throwError(() => errorResponse);
    })
  );
}
